// src/utils/notificationStyles.js
import { AlertTriangle, Image, Cpu, Info } from "lucide-react";

export const NOTIFICATION_STYLES = {
  high: {
    icon: AlertTriangle,
    color: "text-red-400",
    border: "border-red-500/40",
    bg: "bg-red-500/10"
  },
  medium: {
    icon: Cpu,
    color: "text-yellow-400",
    border: "border-yellow-500/40",
    bg: "bg-yellow-500/10"
  },
  low: {
    icon: Info,
    color: "text-sky-400",
    border: "border-sky-500/40",
    bg: "bg-sky-500/10"
  }
};
